<app-bottom-sheet #sheet ariaLabel="ترتیب نمایش جزئیات نماد">
	<ng-template #body>
		<div class="flex flex-col pb-4" data-cy="symbol-detail-sections-content">
			<p class="flex items-start gap-1.5 py-3 text-3.25 text-gray-700 font-medium">
				<ui-icon width="16" height="16" class="shrink-0" iconName="info-box" aria-hidden="true" />
				<span class="flex-1">جهت چیدمان اجزا تابلوی نماد، عناوین را جابه‌جا کنید</span>
			</p>

			<div class="flex h-9 items-center gap-2 text-gray-900 font-medium" data-cy="symbol-detail-section-pinned">
				<ui-icon width="18" height="18" class="shrink-0" iconName="lock" aria-hidden="true" />
				<span class="flex-1 text-3.25">{{ pinnedLabel }}</span>
			</div>

			<div
				class="flex flex-col"
				unSwipeable
				cdkDropList
				role="list"
				aria-label="ترتیب بخش‌های جزئیات نماد"
				(cdkDropListDropped)="onDrop($event)">
				@for (row of rows(); track row.id) {
					<div
						class="flex h-9 cursor-grab items-center gap-2 text-gray-900 font-medium border-t border-stroke-100 bg-gray-000 active:cursor-grabbing"
						cdkDrag
						cdkDragPreviewContainer="parent"
						role="listitem"
						[attr.data-cy]="'symbol-detail-section-' + row.id"
						[attr.aria-label]="row.label">
						<ui-icon width="18" height="18" class="shrink-0" iconName="drag" aria-hidden="true" />
						<span class="flex-1 text-3.25">{{ row.label }}</span>
					</div>
				}
			</div>

			<ui-button
				class="mt-3 w-full"
				variant="mute"
				size="md"
				label="بازگشت به تنظیمات پیش‌فرض"
				extraButtonClasses="w-full gap-1 text-3.25"
				data-cy="symbol-detail-sections-reset"
				[disabled]="isDefaultLayout()"
				(clicked)="onResetToDefault()">
				<ui-icon leftIcon width="18" height="18" iconName="refresh" aria-hidden="true" />
			</ui-button>
		</div>
	</ng-template>
</app-bottom-sheet>
